/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CausaleCdLDTO
 */
export interface CausaleCdLDTO {
    /**
     * 
     * @type {string}
     * @memberof CausaleCdLDTO
     */
    idCausaleCdL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CausaleCdLDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the CausaleCdLDTO interface.
 */
export function instanceOfCausaleCdLDTO(value: object): value is CausaleCdLDTO {
    return true;
}

export function CausaleCdLDTOFromJSON(json: any): CausaleCdLDTO {
    return CausaleCdLDTOFromJSONTyped(json, false);
}

export function CausaleCdLDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CausaleCdLDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idCausaleCdL': json['idCausaleCdL'] == null ? undefined : json['idCausaleCdL'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function CausaleCdLDTOToJSON(json: any): CausaleCdLDTO {
    return CausaleCdLDTOToJSONTyped(json, false);
}

export function CausaleCdLDTOToJSONTyped(value?: CausaleCdLDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idCausaleCdL': value['idCausaleCdL'],
        'descrizione': value['descrizione'],
    };
}

